import UnicornIndicator_mobile from './Indicator_mobile';
import UnicornIndicator_desktop from './Indicator_desktop';
export default function UnicornIndicatorLayout(props) {
  return props.isPhone ? <UnicornIndicator_mobile {...props} /> : <UnicornIndicator_desktop {...props} />;
}
